import Reveal from "./Reveal";
import { tc, tb, tbr } from "../lib/themeStyles";

export default function Footer() {
  return (
    <footer className="border-t-2" style={{ ...tb.page, ...tbr.topAccent }}>
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16">
        <Reveal className="grid grid-cols-1 md:grid-cols-3 gap-10">
          <div>
            <div className="flex items-center gap-3">
              <img
                src={`${process.env.PUBLIC_URL}/logo.png`}
                alt="Malunjkar Engineering Company logo"
                width={64}
                height={64}
                className="h-16 w-16 rounded-full object-cover ring-1 ring-white/10 mix-blend-screen"
              />
              <div>
                <div className="text-[18px] font-extrabold tracking-[-0.02em]" style={tc.primary}>
                  MALUNJKAR
                </div>
                <div className="label-cap mt-1" style={tc.muted}>
                  Engineering Company
                </div>
              </div>
            </div>
            <p className="mt-6 text-[14px] leading-[1.7] max-w-xs" style={tc.muted}>
              Precision contract manufacturing for international supply chains. Pune, Maharashtra,
              India.
            </p>
          </div>
          <div>
            <div className="label-cap mb-4" style={tc.muted}>
              Navigate
            </div>
            <ul className="space-y-3 text-[14px]">
              {[
                "#capabilities:Capabilities",
                "#materials:Materials",
                "#supply-chain:Supply Chain",
                "#rfq:Submit RFQ",
              ].map((item) => {
                const [href, label] = item.split(":");
                return (
                  <li key={href}>
                    <a href={href} className="link-reveal">
                      {label}
                    </a>
                  </li>
                );
              })}
            </ul>
          </div>
          <div>
            <div className="label-cap mb-4" style={tc.muted}>
              Contact
            </div>
            <ul className="space-y-3 text-[14px]">
              <li>
                <a href="mailto:info@malunjkar.com" className="link-reveal">
                  info@malunjkar.com
                </a>
              </li>
              <li>
                <a href="tel:+918999873418" className="link-reveal">
                  +91 89998 73418
                </a>
              </li>
              <li>
                <span style={tc.muted}>Pune, Maharashtra, India</span>
              </li>
            </ul>
          </div>
        </Reveal>

        <div
          className="mt-14 pt-6 border-t flex flex-col md:flex-row items-start md:items-center justify-between gap-4"
          style={tbr.default}
        >
          <div className="text-[12px]" style={tc.muted}>
            © 2025 Malunjkar Engineering Company
          </div>
          <div className="flex flex-wrap gap-6 text-[12px]">
            <a href="#" className="link-reveal">
              Privacy Policy
            </a>
            <a href="#" className="link-reveal">
              Terms of Contract Manufacturing
            </a>
            <a href="#" className="link-reveal">
              Cookie Policy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
